import React, { ReactNode, useMemo } from 'react';
import { DatePicker, Form, FormControlProps, Text } from 'rsuite';
import dayjs from 'dayjs';

type AnnotatedDatePickerProps = {
  annotation?: () => string | undefined;
  format?: string;
  label: string;
  subtitle?: () => ReactNode;
} & Omit<
  FormControlProps<string, string>,
  'accepter' | 'onSelect' | 'format' | 'oneTap' | 'editable'
>;

const AnnotatedDatePicker = ({
  annotation = () => undefined,
  format = 'MM-DD-YYYY',
  label,
  name,
  onChange,
  subtitle = () => undefined,
  value,
  ...rest
}: AnnotatedDatePickerProps) => {
  const formattedValue = useMemo(() => {
    const d = dayjs(value);
    if (d.isValid()) {
      return d.toDate();
    }
    return undefined;
  }, [value]);

  const onInternalChange = (date: Date | null, ev: React.SyntheticEvent) => {
    const dayjsDate = dayjs(date);
    if (onChange) {
      if (dayjsDate.isValid()) {
        const formatted = dayjsDate.format(format);
        onChange(formatted, ev);
      } else {
        onChange('', ev);
      }
    }
  };

  return (
    <Form.Group controlId={name}>
      <Form.ControlLabel>
        <Text className="text-bold">{label}</Text>
        {subtitle && <Text>{subtitle()}</Text>}
      </Form.ControlLabel>
      <Form.Control
        accepter={DatePicker}
        key={value ? 'date-picker' : 'empty-date-picker'}
        name={name}
        onChange={onInternalChange}
        value={formattedValue}
        {...rest}
      />
      {annotation()}
    </Form.Group>
  );
};

export default AnnotatedDatePicker;
